import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
})
export class PromptComponent  implements OnInit {
  @Input() icon: string
  @Input() text: string
  @Input() btnText: string
  constructor(
    private globalService: GlobalService,
    private nav: NavController
  ) { }

  ngOnInit() {}
  close(){
    this.globalService.closeModal();
  }

  goTo(){
    if(this.btnText == 'My Earnings'){
      this.nav.navigateForward('/reservations')
    } else {
      this.nav.navigateForward('/otp-request')
    }
    this.globalService.closeModal();
  }
}
